/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pm_Card_OpenInputs */

const cs_pm_card_open = /** @type {(inputs: Pm_Card_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Otevřít mapování`)
};

const en_pm_card_open = /** @type {(inputs: Pm_Card_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open mapping`)
};

/**
* | output |
* | --- |
* | "Open mapping" |
*
* @param {Pm_Card_OpenInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const pm_card_open = /** @type {((inputs?: Pm_Card_OpenInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pm_Card_OpenInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pm_card_open(inputs)
	return cs_pm_card_open(inputs)
});